import React from 'react';
import Points from 'components/Points';
import { eliteFeeCopy, formatFeePct } from 'config/economyCopy';
import { useTransactionFeeRate } from 'hooks/useTransactionFeeRate';
import FeatureCardLayout from './FeatureCardLayout';
import './ZeroFeesCard.css';

interface ZeroFeesCardProps {
  isElite: boolean;
}

/**
 * The transaction-fee half of the sentence, from the live rate and Elite
 * discount. Without a loaded rate it names the fee without a number rather
 * than printing a stale one.
 */
export const eliteWaiverSentence = (ratePct?: number, eliteDiscountPct?: number): string => {
  if (ratePct == null || eliteDiscountPct == null) {
    return 'Elite waives the monthly maintenance fee and the transaction fee on trades.';
  }
  if (eliteDiscountPct >= 100) {
    return `Elite waives both the monthly maintenance fee and the ${formatFeePct(ratePct)} transaction fee on trades.`;
  }
  return `Elite waives the monthly maintenance fee and takes ${eliteFeeCopy(ratePct, eliteDiscountPct)} on trades.`;
};

const ZeroFeesCard: React.FC<ZeroFeesCardProps> = ({ isElite }) => {
  const { ratePct, eliteDiscountPct } = useTransactionFeeRate();
  const preview = (
    <div className="zero-fees-card-preview">
      <Points points={0} type="big" />
    </div>
  );

  const cta = (
    <p className="feature-card-aspirational">
      {isElite
        ? 'Your zero-fee rate is locked in for the life of your membership'
        : 'Limited-time offer for founding members'}
    </p>
  );

  return (
    <FeatureCardLayout
      title="Zero Point-Fees, Always"
      description={`${eliteWaiverSentence(ratePct, eliteDiscountPct)} Sign up during the launch promotion and your zero-fee rate is locked in for the life of your membership.`}
      previewContent={preview}
      ctaContent={cta}
      className="zero-fees-card"
    />
  );
};

export default ZeroFeesCard;
